import { usePagination } from 'react-instantsearch';

// Since the pagination is not mounted when displaying the landing page,
// we need to include it here to prevent state loss.
// If more widgets are conditionally rendered, they should also be added here.
export function useVirtualWidgets(): void {
	usePagination();
}
